var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBondDoublePurpleSolid = function SvgBondDoublePurpleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 76,
    viewBox: "0 0 155 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.741 75.253c15.882-.055 29.416-10.13 34.656-24.25a5.465 5.465 0 0 1 5.12-3.587h.464c2.286 0 4.32 1.437 5.12 3.587 5.24 14.124 18.77 24.195 34.655 24.25 19.899.07 36.463-15.842 37.217-35.8.802-21.237-16.109-38.706-37.086-38.706C101.736.747 88 11.1 82.897 25.557c-.774 2.194-2.83 3.674-5.15 3.674-2.32 0-4.376-1.48-5.15-3.674C67.493 11.1 53.756.747 37.606.747 16.63.747-.28 18.217.521 39.453c.757 19.958 17.32 35.873 37.217 35.8h.003Z",
    fill: "#BCADC8"
  })));
};
export default SvgBondDoublePurpleSolid;